import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        height: '58px',
        padding: '0px 0px 0 15px',
        "& h1": {
            padding: '0px 0px 0 15px',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        }

    },
    rightHeader: {
        marginLeft: 'auto',
        "& h2": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: '700',
            fontSize: '14px',
            lineHeight: '14px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#2D4D95',
        },
        "& .greyText": {
            color: '#838383',
            display: 'inline-block',
            margin: '0 15px',
        }
    },
    container: {
        width: "100%",
        display: 'flex',
        height: 'calc(100% - 122px)'
    },
    backBtn: {
        background: 'white',
        padding: '5px 15px',
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'17px',
        fontWeight: 600,
        textTransform: 'capitalize',
        cursor:'pointer',
    },
    leftContainer: {
        width: '30%',
        background: '#FFFFFF',
        borderRight: '1px solid #D9DCE0',
        transitionProperty: 'width',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'linear',
    },
    leftContainerToggle: {
        width: window.isMobileView ? '0px': '57px',
        background: '#FFFFFF',
        borderRight: '1px solid #D9DCE0',
        // transitionProperty: 'width',
        // transitionDuration: '0.2s',
        // transitionTimingFunction: 'linear',

        "& .MuiInput-root": {
            display: 'none !important'
        },
        "& .TextHidden":{
            display:window.isMobileView ? 'block' :'none'
        }
    },

    leftContainerMobilefull: {
        width: '100% !important',
    },
    leftContainerMobileZero: {
        width: '0% !important',
    },

    rightContainerMobileFull: {
        width: '100% !important', 
    },

    rightContainerMobileZero: {
        display:'none',
        width: '0% !important', 
        
    },
    
    leftHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        "& svg": {
            marginRight: '2px',
            marginLeft: '2px',
            cursor: 'pointer',
        },
        "& .MuiInputBase-root": {
            width: '100%',
            display: 'flex',
            // border: 'none',
            boxSizing: 'border-box',
            margin: '5px 0px 5px',
            backgroundColor: 'white',
            minHeight: 35.63,
            padding: '0px 8px 0px 12px',
            height: 35.63,
            opacity: 0.7,
            border: '0.5px solid #777D80',
            borderRadius: 25,
        },
        "& .MuiInput-underline::before": {
            border: 'none'
        },
        "& .MuiInput-underline::after": {
            border: 'none'
        }
    },
    userListContainer: {
    },
    userList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        "& .active": {
            backgroundColor: "#F5F5F5"
        },
        "& li": {
            display: 'flex',
            alignItems: 'center',
            padding: "8px 12px",
            cursor: 'pointer',
            "&:hover": {
                backgroundColor: "#F5F5F5"
            },
            "& img": {
                width: "40px",
                height: '40px',
                borderRadius: '50%',
                marginRight: '10px',
            },
            "& .MuiBadge-anchorOriginTopRightRectangle": {
                transform: 'none'
            },
            "& .MuiBadge-badge": {
                color: '#fff',
                position: 'relative',
                backgroundColor: '#0686D8'
            },
            "& div": {
                width: "100%",
                display: 'flex',
                justifyContent: 'space-evenly',
                flexDirection: 'column',
            },
            "& span": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            },
            "& .userName": {
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: '14px',
                color: '#011627',
            },
            "& .messageTime": {
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '16px',
                color: '#707991',
            },
            "& .messageText": {
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '21px',
                color: '#707991',
                whiteSpace: 'nowrap',
                width: '265px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        }
    },
    rightContainer: {
        width: '100%',
        background: '#F6F6F6',
        borderRight: '1px solid #D9DCE0',
    }
}));